import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CustomSectionComp } from '../../components/custom-section/custom-section';
import MainCarousel from '../../components/home/MainCarousel';
import { selectBannersState } from '../../redux/selectors/application-selectors';

const CustomSection = () => {
  const { id } = useParams();

  const { categoriesMainCarousel, ready, error } = useSelector(selectBannersState);
  const hasBanners = ready && !error && categoriesMainCarousel && categoriesMainCarousel.length > 0;
  const isLoadingBanners = !ready;

  return (
    <div>
      <MainCarousel
        defaultB={true}
        defaultOnly={true}
        id={id}
        showHomeOnly={true}
      />
      {!hasBanners && !isLoadingBanners && <CustomSectionComp id={id} />}
    </div>
  );
};

export default CustomSection;
